import * as service from './healthsafety.service'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value != '' && value) {
        var letter = /^[-+]?\d+$/;
        value = value + ''
        if (!value.match(letter)) {
          callback(new Error('value must be a number'));
        }
        // this.$refs.addCompliance.resetFields('LicenseCount');
      }

      callback();
    };
    return {
      compliance_columns: ['InventoryName', 'Brand', 'Category', 'Type', 'NameAndBrand','CategoryAndType', 'Actions'],
      optionstable: {
        skin: this.$hydrowareCommonJS.hydrowareTableSkin,
        headings: {
          InventoryName: 'Inventory Name',
          Brand: 'Brand Name',
          Category: 'Category Name',
          NameAndBrand: 'Name/Brand',
          CategoryAndType: 'Category/Type',
          Actions: ''
        },
        columnsClasses: {
          "Actions":"hydroware-2-button-column",
          "InventoryName":"hidden-xs hidden-sm",
          "Brand":"hidden-xs hidden-sm",
          "Category":"hidden-xs hidden-sm",
          "Type":"hidden-xs hidden-sm",
          "NameAndBrand":"hydroware-label-in-column col-xs-6 hidden-md hidden-lg hidden-xl",
          "CategoryAndType":"hydroware-label-in-column col-xs-6 hidden-md hidden-lg hidden-xl"
        },

        labelPosition: 'top',
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        /*  sortable: ["ActionDate","Description", "CommentedBy", "ActionTypeName"],*/
        sortable: [],
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },

      Inventory: {

        "InventoryId": '',
        "InventoryTypeId": '',
        "InventoryCategoryId": '',
        "Model": '',
        "Color": '',
        "Size": '',
        "Description": '',
        "Notes": '',
        "LocationId": '',
        "LocationName": '',
        "StorageLocation": '',
        "LeadTime": '',
        "UsageRate": '',
        "Date": '',
        "Quantity": '',
        "UOM": '',
        "Suppliers": [],
        "InventoryName": "",
        "Brand": "",
        "Category": "",
        "Type": "",
        /*  "InventoryDetailsId": ''*/


      },
      addComplianceCopy: {},
      rules: {

        InventoryTypeId: [

          {
            required: true,
            message: 'This field is required'
          },

        ],
        InventoryCategoryId: [

          {
            required: true,
            message: 'This field is required'
          },

        ],
        InventoryId: [

          {
            required: true,
            required: true,
            message: 'This field is required'
          },

        ],
        Quantity: [

          {
            validator: validatePass
          }
        ],
        Brand: [

          {
            required: true,
            message: 'This field is required'
          },

        ]
      },
      Inventories: [],
      inventoryPreRequisites: [],
      types: [],
      categories: [],
      cinventories: [],
      suppliers: [],
      modalTitle: '',
      locationId: 25,
      isediting: false,
      isaddding: false,
      isAddingOrEditing:"", //FG - FOOF - After Cert - First Release Security (7)
      locationName: ''

    }
  },
  mounted() {
    let context = this
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      if (context.locationId) {
        context.GetAllInventoryItems(context.locationId)
      }
    })

    // this.GetAllInventoryItems(this.locationId)
    this.PreRequisites()

  },

  methods: {

    addCompliancevit() {
      this.isaddding = true
      this.isAddingOrEditing="A"

      this.Inventory = {

        "InventoryId": '',
        "InventoryTypeId": '',
        "InventoryCategoryId": '',
        "Model": '',
        "Color": '',
        "Size": '',
        "Description": '',
        "Notes": '',
        "LocationId": '',
        "LocationName": '',
        "StorageLocation": '',
        "LeadTime": '',
        "UsageRate": '',
        "Date": '',
        "Quantity": '',
        "UOM": '',
        "Suppliers": [],
        "InventoryName": "",
        "Brand": "",
        "Category": "",
        "Type": "",
        /*      "InventoryDetailsId": ''*/


      }

    },

    Getcategory(typeId) {
      let context = this

      this.Inventory.InventoryCategoryId = window.edCat ? window.edCat : ""
      window.edCat = ""
      context.categories = []
      this.types.map(function (item) {

        item["InventoryCategoryList"].map(function (item1) {

          if (item1["TypeIdId"] === typeId) {
            context.categories.push(item1)
          }

        });


      })

    },
    getInventory(id) {
      let context = this
      context.cinventories = []
      this.categories.map(function (item) {

        item["InventoryList"].map(function (item1) {

          if (item1["InventoryCategoryId"] === id) {
            context.cinventories.push(item1)
          }

        });


      })

    },

    showCompliancevit() {
      this.isaddding = false
      this.isediting = false
      this.isAddingOrEditing=""
    },


    GetAllInventoryItems(locationId) {
      let context = this
      loader.startLoader()
      service.GetAllInventoryItems(locationId).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          context.Inventories = []                   
          loader.stopLoader()
          return;
        }

        if (response && response != null) {
          context.Inventories = response
          tooltip.startTooltip(50)
        } else {

          context.Inventories = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    GetInventoryDetialById(Id) {
      let context = this
      loader.startLoader()
      service.GetInventoryDetialById(Id).then(function (response) {
        if (response.InventoryCategoryId) {
          window.edCat = response.InventoryCategoryId
          //FG - FOOF - the line had been commented out by Digiclarity
          //  but it needed to be reinstated for element-ui vers 2.4.11
          //  so the category dropdown would be populated when the page is
          //  initially loaded
          context.Getcategory(response.InventoryTypeId)
          //FG - FOOF - added the line below so the inventory drop down would populate
          //  when the page is initially loaded
          context.getInventory(response.InventoryCategoryId) 
        }
        if (response.InventoryId) {
          //context.getInventory(response.InventoryId)
        }

        if (response && response != null) {


          context.Inventory = response

          context.Inventory["InventoryDetailsId"] = response.InventoryDetailsId
          if (response.Date) {
            context.Inventory["Date"] = new Date(response.Date)
          }
        }


        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    PreRequisites() {
      let context = this
      loader.startLoader()
      service.PreRequisites().then(function (response) {

        if (response && response != null) {
          context.inventoryPreRequisites = response
          context.types = response.Inventory["InventoryTypeList"]
          context.suppliers = response.supplier
        }


        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    /*
    del: function (data) {alert("INVEN");if(1==1) return;
      var ID = data.row.InventoryDetailsId
      let context = this
      context.$confirm('Are you sure you want to delete' + data.row.InventoryName+'?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        loader.startLoader()
        service.DeleteInventory(ID).then(function (response) {
          context.GetAllInventoryItems(context.locationId)
          loader.stopLoader()
          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })
        }, (error) => {
          loader.stopLoader()
          this.$notify({
            title: 'Error',
            message: error.responseJSON.Message,
            type: 'error'
          })
        })
      }).catch(() => {
      })
    },
    */
    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    del: function (data) {
      var ID = data.row.InventoryDetailsId
      let context = this
      var opts = {message: 'Are you sure you want to delete ' + data.row.InventoryName + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteInventoryRow.bind(null,ID))
    },
    deleteInventoryRow(ID) {
      var context = this;
      loader.startLoader()
      service.DeleteInventory(ID).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
          loader.stopLoader()
          return;
        }

        context.GetAllInventoryItems(context.locationId)
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
      },
      (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },
    cancelpopup: function () {

      $('#Addkudosmodel').modal('hide')
    },

    editcol: function (data) {

      var ID = data.row.InventoryDetailsId
      let context = this
      context.EditableColID = ID

      context.GetInventoryDetialById(ID)

      context.isediting = true
      context.isAddingOrEditing="E"

    },


    AddInventoryItem(formName) {


      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()

          context.Inventory['LocationId'] = context.locationId
          if (context.Inventory.Date) {
            context.Inventory['Date'] = context.$options.filters.fdate(context.Inventory.Date)
          }

          service.AddInventoryItem(context.Inventory).then(function (response) {
            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {
              loader.stopLoader()
              return;
            }
            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Inventory Details Added',
              type: 'success'
            })
            context.GetAllInventoryItems(context.locationId)
            context.isediting = false
            context.isaddding = false
            context.isAddingOrEditing=""

          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'INVENTORY - 1 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },


    UpdateInventoryDetails(formName) {


      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()
          context.Inventory['LocationId'] = context.locationId
          if (context.Inventory.Date) {
            context.Inventory['Date'] = context.$options.filters.fdate(context.Inventory.Date)
          }

          // context.addCompliance['Id'] =
          service.UpdateInventoryDetails(context.Inventory).then(function (response) {

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                 
              loader.stopLoader()
              return;
            }

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Inventory Details  Updated',
              type: 'success'
            })
            context.GetAllInventoryItems(context.locationId)
            context.isediting = false
            context.isaddding = false
            context.isAddingOrEditing=""

          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'INVENTORY -2 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },


    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  watch: {

    isediting: function (val) {
      this.$router.app.$emit('sidebar_hide', val)
    },
    isaddding: function (val) {
      this.$router.app.$emit('sidebar_hide', val)
    }


  },
}



// WEBPACK FOOTER //
// ./src/pages/HealthSafety/inventory.controller.js